export default "__VITE_ASSET__3d56d9df__"